import { render, staticRenderFns } from "./GlobalSearch.vue?vue&type=template&id=6ee5f7c1&scoped=true&"
import script from "./GlobalSearch.vue?vue&type=script&lang=js&"
export * from "./GlobalSearch.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSearch.vue?vue&type=style&index=0&id=6ee5f7c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee5f7c1",
  null
  
)

export default component.exports